import React from "react";
import './Footer.css'
const ModalFooterPagePro = () => {
  return (
    <div className="footer">
      <div className="foot">
        <h2>Our Servicess</h2>
        <li>Lets with Javascript</li>
        <li>Lets with React</li>
        <li>Lets with Wordpress</li>
        <li>Lets with App Development</li>
        <li>Lets with Web Design</li>
      </div>
      <div className="foot">
        <h2>Our Team</h2>
        <li>Daisy Gabriela</li>
        <li>Addison Smith</li>
        <li>Cosmetic Dentistry</li>
        <li>Sayed Miyad</li>
        <li>See More Details........</li>
      </div>
      <div className="foot">
        <h2>Social Link</h2>
        <span className="social-icon"><a href="https://www.facebook.com/mehedi.hasanshowrov.14"><i className="fab fa-facebook-square"></i></a></span>
        <span className="social-icon"><a href="https://www.instagram.com/mehedihasanshowro1/"><i className="fab fa-instagram-square"></i></a></span>
        <span className="social-icon"><a href="https://twitter.com/?lang=en"><i className="fab fa-twitter-square"></i></a></span>
      </div>
    </div >
  );
};

export default ModalFooterPagePro;
